import { VIDEO_FINISHED, INIT_SIGNOUT, INIT_POINTS_MASTER_DATA, SELECTED_OPTION, INIT_SIGNIN, HIDE_SNACKBAR, TESTCASE_COMPLETED, GET_RESULT } from '../Actions/actionTypes';


const INIT_STATE = {
    userID: null,
    rules: {},
    points: 0,
    problemPoints: 10,
    snackBarStatus: false, 
    snackBarText: {
        points: 0,
        activity: ''
    }
};

const Points = (state = INIT_STATE, action) => {

    let newState;
    switch(action.type){
        case INIT_SIGNIN:
        case INIT_POINTS_MASTER_DATA:
            return {
                ...state,
                userID: action.userID,
                rules: action.ruleSets,
                points: action.points,
                problemPoints: action.problemPoints
            }

        case INIT_SIGNOUT:
            return INIT_STATE;
            
        case VIDEO_FINISHED:
            return state;

        case SELECTED_OPTION:
            // Show snack bar for puzzle completion
            newState = state;
            if(!action.isPreviouslyCompleted){
                if(action.status && !action.progress.questionAvailable){
                    if(action.progress.isCompleted && action.status){
                        newState =  {
                            ...newState,
                            snackBarStatus: true,
                            snackBarText: 'You successfully Completed Puzzles'
                        }
                    }

                    // updatePointsAPI(state.userID, state.rules, 'PUZZLE_ATTEMPT', {
                    //     courseID: action.details.courseID,
                    //     moduleID: action.details.moduleID
                    // });

                    return newState;
                }
            }
            return newState;
            
        case TESTCASE_COMPLETED:
            // Show snack bar for IDE
            newState = state;
            if(!action.isPreviouslyCompleted){
                if(!action.details.questionAlreadyCompleted && action.isCompleted){
                    newState =  {
                        ...newState,
                        snackBarStatus: true,
                        // snackBarText: `You earned ${newState.rules['IDE_QUESTION_SOLVED']} coins for ${action.testCaseLength === 0 ? 'Completed Problems' : 'Solving All TestCases'}`
                    }
                    // // Update Points for correct answer
                    // updatePointsAPI(state.userID, state.rules, 'IDE_QUESTION_SOLVED', {
                    //     courseID: action.details.courseID,
                    //     moduleID: action.details.moduleID
                    // });

                    return newState;
                }
            }
            return newState;
            
        case GET_RESULT:
            //show snack bar for Quiz
            if(!action.moduleComplete){
                return {  
                    ...state,
                    points: state.points + action.points,                                                                                         
                    snackBarStatus: true,
                    snackBarText: `You earned ${action.points} coins for Completing Quiz`
                }
            }
            return state;
            
        case HIDE_SNACKBAR:
            return {
                ...state,
                snackBarStatus: false,
                snackBarText: INIT_STATE.snackBarText
            }

        default:
            return state;
    }
}

// const updatePointsAPI = (userID, rules, activity, details={}) => Axios.post(CONFIG.apiURL+`/points/${userID}`, {
//     points: rules[activity],
//     activity,
//     ...details
// });

export default Points;